import {FilterData, FilteringFlow} from "@filtering.js/filtering.js/ui";
import {animateInViewport, lazyLoadImages} from "./transition";
import SmoothScroll from 'smooth-scroll';

$( function() {
	var $filtering = $( '.filtering' );
	if ( $filtering.length ) {
		var filteringElement = $filtering[ 0 ];

		class MyFilteringFlow extends FilteringFlow {
			handleFilterResult( result, filterData ) {
				super.handleFilterResult( result );
				$( '.no-results' ).toggleClass( 'hidden', result.filteredItems.length > 0 );
				animateInViewport();
				lazyLoadImages();

				for ( const item of result.allItems ) {
					item.data.element.classList.remove( 'active' );
				}

				let allFilterChecked = true;
				for ( const groupResult of result.groups ) {
					for ( const filterResult of groupResult.filters ) {
						$( `.items-group-header[data-year="${filterResult.schemaFilter.name}"]` ).toggleClass( 'hidden', filterResult.filteredItems.length === 0 );

						const filterElement = filterResult.schemaFilter.data.element;
						if ( filterElement.classList.contains( 'checked' ) ) {
							let groupTitle = '';
							if ( filterElement.dataset.filterType === 'all' ) {
								groupTitle = $( filterElement ).parents( '.filter-group' ).find( '.filter-group-title' ).attr( 'data-default-title' );
							} else {
								groupTitle = filterElement.innerHTML;
							}
							$( filterElement ).parents( '.filter-group' ).find( '.filter-group-title' ).html( groupTitle );
						}

						if ( filterElement.dataset.filterType !== 'all' && filterElement.classList.contains( 'checked' ) ) {
							allFilterChecked = false;
						}
					}
				}
				$( '.blog .filter-items-container .filtering-filter.disabled' ).hide();
				$( '.filter-items-container' )
					.stop().slideUp( 'fast' )
					.attr( 'data-toggle-slide-direction', 'down' );
				// window.msnry.masonry();

				$( '.enable-all-filters' ).toggleClass( 'checked', allFilterChecked );

				for ( const item of result.allItems ) {
					$( item.data.element ).toggleClass( 'item-active', !allFilterChecked && result.filteredItems.includes( item ) );
				}

				const ids = [];
				for ( const item of result.filteredItems ) {
					ids.push( item.data.element.id );
				}

				if ( $( '.map' ).length > 0 ) {
					updateGoogleMapMarkers( ids );
				}

				updateBadges( result, filterData );

				storeFiltersToHash( filterData );

				setTimeout( animateInViewport, 0 );
				setTimeout( lazyLoadImages, 0 );
			}
		}

		const storeHash = filteringElement.dataset.storeHash === 'true';
		const filteringFlow = new MyFilteringFlow( filteringElement, {
			filteredItemClass: 'hidden',
			triggerFilterAfterInitializing: !storeHash,
		} );
		window.addEventListener( 'hashchange', loadFiltersFromHash );
		if ( storeHash ) {
			loadFiltersFromHash();
		}
		$( '.filtering-filter' ).click( function( event ) {
			event.preventDefault();
			$( '.employee-search' ).val( '' );
			animateInViewport();
			lazyLoadImages();
		} );
		$( '.enable-all-filters' ).click( function( event ) {
			event.preventDefault();
			for ( const group of filteringFlow.schema.groups ) {
				for ( const filter of group.filters ) {
					const filterElement = filter.data.element;

					if ( filterElement.dataset.filterType === 'all' ) {
						filterElement.classList.add( filteringFlow.parser.options.filterCheckedClass );
					} else {
						filterElement.classList.remove( filteringFlow.parser.options.filterCheckedClass );
					}
				}
			}
			filteringFlow.filter();
		} );
		window.filteringFlow = filteringFlow;

		function updateBadges( result, filterData ) {
			const $propertyFilterBadges = $( '.property-filter-badges' );
			$propertyFilterBadges.empty();
			const badgeClasses = $propertyFilterBadges.attr( 'data-badge-style' );

			const currentCheckedFilters = [];
			for ( const [groupName, checkedFilters] of filterData.checkedFilters ) {
				for ( const filterName of checkedFilters ) {
					currentCheckedFilters.push( {
						group: groupName,
						filter: filterName,
					} );
				}
			}

			for ( const group of result.groups ) {
				const schemaGroup = group.schemaGroup;
				for ( const filter of group.filters ) {
					const schemaFilter = filter.schemaFilter;
					if ( !schemaFilter.name ) {
						continue;
					}

					for ( const checkedFilter of currentCheckedFilters ) {
						if ( schemaGroup.name === checkedFilter.group && schemaFilter.name === checkedFilter.filter ) {
							const label = $( schemaFilter.data.element ).text().trim();
							const $badge = $( `
<a href="javascript:;"
   class="whitespace-nowrap invisible-link inline-flex items-center pl-0.5 pr-2.5 py-0.5 rounded-full ${badgeClasses} active-filter">
	<span class="transition-all bg-contain bg-center bg-no-repeat w-[24px] aspect-square icon"></span> <span
	class="paragraph-3 pl-1 pb-[1px]">${label}</span>
</a>` );
							$badge.click( ( event ) => {
								event.preventDefault();
								schemaFilter.data.element.click();
							} );
							$propertyFilterBadges.append( $badge );
						}
					}
				}
			}
		}


		function loadFiltersFromHash() {
			if ( !storeHash ) {
				return;
			}

			const hash = decodeURIComponent( window.location.hash.substring( 1 ) );
			const filteringData = new FilterData();
			if ( hash ) {
				const filteringAsQueryParams = new URLSearchParams( hash );
				for ( const [groupName, filterName] of filteringAsQueryParams ) {
					filteringData.checkFilter( groupName, filterName );
				}
			}
			filteringFlow.filter( filteringData );
		}

		function storeFiltersToHash( filterData ) {
			if ( !storeHash ) {
				return;
			}

			const filteringAsQueryParams = new URLSearchParams();
			for ( const [groupName, checkedFilters] of filterData.checkedFilters ) {
				for ( const checkedFilter of checkedFilters ) {
					filteringAsQueryParams.append( groupName, checkedFilter );
				}
			}
			const newHash = filteringAsQueryParams.toString();
			updateHash( newHash );
		}

		function updateHash( newHash ) {
			if ( newHash !== window.location.hash.substring( window.location.hash.indexOf( '#' ) + 1 ) ) {
				if ( newHash ) {
					window.location.hash = newHash;
				} else {
					const uri = window.location.toString();
					history.pushState( true, '', uri.substring( 0, uri.indexOf( "#" ) ) );
				}
			}
		}
	}
} );
